import { useHandleModalState } from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/state/useHandleModalState";
import { useStoreOpeningDateState } from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/state/useStoreOpeningDateState";
import { buildFaireDirectParams } from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/utils/paramBuilders";
import { useFaireDirectBrand } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import signUpPersonal, {
  QueryParameters as SignUpQueryParameters,
} from "@faire/web-api--source/routes/www/welcome/r/personal";
import { removeLocaleFromUrl } from "@faire/web/ui/routing/util";
import { usePathname, useSearchParams } from "next/navigation";
import { useMemo } from "react";

export const useBuildSignUpUrl = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const signUpParams = SignUpQueryParameters.parse(searchParams.toString());
  const { faireDirectBrand, faireDirectBrandToken, faireDirectBrandAlias } =
    useFaireDirectBrand();
  const { modalVariant } = useHandleModalState();
  const faireDirectParams = buildFaireDirectParams(
    signUpParams,
    modalVariant,
    faireDirectBrandToken,
    faireDirectBrand?.name,
    faireDirectBrandAlias
  );
  const { storeOpeningDate } = useStoreOpeningDateState();

  return useMemo(() => {
    const url = signUpPersonal({
      ...signUpParams,
      // Requires an email to not redirect back to homepage
      email: "placeholder@email.com",
      source: removeLocaleFromUrl(pathname),
      storeOpeningDate:
        storeOpeningDate.value && storeOpeningDate.value > 0
          ? `${storeOpeningDate.value}`
          : undefined,
      ...faireDirectParams,
    });
    return url.includes("?") ? `${url}&isIframe=1` : `${url}?isIframe=1`;
  }, [pathname, signUpParams, storeOpeningDate.value, faireDirectParams]);
};

export const usePerfBuildSignUpUrl = (location: {
  pathname: string;
  search: string;
}) => {
  const signUpParams = SignUpQueryParameters.parse(location.search);
  const { storeOpeningDate } = useStoreOpeningDateState();

  return useMemo(() => {
    const url = signUpPersonal({
      ...signUpParams,
      // Requires an email to not redirect back to homepage
      email: "placeholder@email.com",
      source: removeLocaleFromUrl(location.pathname),
      storeOpeningDate:
        storeOpeningDate.value && storeOpeningDate.value > 0
          ? `${storeOpeningDate.value}`
          : undefined,
    });
    return url.includes("?") ? `${url}&isIframe=1` : `${url}?isIframe=1`;
  }, [location.pathname, signUpParams, storeOpeningDate.value]);
};
